import { Action, action, Thunk, thunk } from 'easy-peasy';

export interface ServiceWorkerStoreModel {
  isOpen: boolean;
  close: Action<ServiceWorkerStoreModel>;
  open: Action<ServiceWorkerStoreModel, ServiceWorkerRegistration>;
  toggle: Action<ServiceWorkerStoreModel>;
  sw: null | ServiceWorkerRegistration;
  update: Thunk<ServiceWorkerStoreModel>;
}

const serviceWorkerStoreModel: ServiceWorkerStoreModel = {
  isOpen: false,
  sw: null,
  close: action((s) => {
    s.isOpen = false;
  }),
  open: action((s, sw) => {
    s.isOpen = true;
    s.sw = sw;
  }),
  toggle: action((s) => {
    s.isOpen = !s.isOpen;
  }),
  update: thunk((_, __, { getState }) => {
    const sw = getState().sw;
    if (!sw) return;
    const registrationWaiting = sw.waiting;
    if (!registrationWaiting) return;
    registrationWaiting.postMessage({ type: 'SKIP_WAITING' });
    registrationWaiting.addEventListener('statechange', (e: any) => {
      if (e.target.state === 'activated') {
        window.location.reload();
      }
    });
  }),
};

export default serviceWorkerStoreModel;
